<template>
    <div class="timeline-container timeline">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1>Berufliche Stationen</h1>
                    <p>Hier sehen Sie eine Auswahl meines bisherigen beruflichen Werdegangs. <br> Bei Fragen sprechen
                        Sie mich gerne an.</p>
                </div>
            </div>
            <div class="swiper-container">
                <div class="swiper-wrapper timeline">
                    <div class="swiper-slide" v-for="(item, key) in timeline_data" :key="key">
                        <div class="timestamp">
                            <span class="date">{{item.dateLabel || '&nbsp;'}}</span>
                        </div>
                        <div class="status">
                            <span>{{item.school}} - {{item.address}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Timeline',
        components: {},
        data () {
            return {
                timeline_data: [
                    {
                        "school": "Lehrstuhl für Schuldrecht",
                        "address": "Luarasi Universität, Tirana"
                    },
                    {
                        "school": "Lehrstuhl für Zivilrecht",
                        "address": "amerik. Universität Tirana",
                        "dateLabel": "2011 - 2012"
                    },
                    {
                        "school": "Lehrstuhl für Zivilrecht",
                        "address": "Universität Tirana",
                        "dateLabel": "2012 - 2014"
                    },
                    {
                        "school": "Rektor",
                        "address": "Universität UNT Tirana",
                        "dateLabel": "2014 - 2016"
                    },
                    {
                        "school": "Rechtsanwalt",
                        "address": "Kanzlei Lamaj",
                        "dateLabel": "seit 2016",
                    }
                ]
            };
        },
        methods: {}
    };
</script>
